// Central calculator registry. Add a calculator by importing its config and
// adding it to CALCULATORS — no architecture changes required.
import { mortgagePaymentConfig, mortgageAffordabilityConfig } from "./mortgage";
import {
  compoundInterestConfig, tfsaGrowthConfig, rrspGrowthConfig,
  fhsaConfig, respConfig, gicConfig,
} from "./investing";
import { rrspTaxSavingsConfig, retirementConfig } from "./retirement-tax";
import { netWorthConfig, debtPayoffConfig } from "./networth-debt";
import { budgetConfig, emergencyFundConfig, savingsGoalConfig } from "./budgeting";
import {
  mortgageRefinanceConfig, mortgageRenewalConfig, helocConfig,
  landTransferTaxConfig, rentVsBuyConfig,
} from "./mortgage-extra";
import { takeHomePayConfig, incomeTaxConfig, capitalGainsConfig, salesTaxConfig } from "./taxes";
import {
  cppOasConfig, rrifConfig, respWithdrawalConfig, fireConfig, merConfig,
} from "./planning-extra";
import { carLoanConfig, lineOfCreditConfig, creditCardConfig } from "./loans";
import {
  creditUtilizationConfig, lifeInsuranceConfig, rentAffordabilityConfig,
  freelancerTaxConfig, firstTimeHomeBuyerConfig, inflationImpactConfig, debtToIncomeConfig,
} from "./new-tools";

export const CALCULATORS = [
  // Mortgage & Home
  mortgagePaymentConfig,
  mortgageAffordabilityConfig,
  mortgageRefinanceConfig,
  mortgageRenewalConfig,
  helocConfig,
  landTransferTaxConfig,
  rentVsBuyConfig,
  // Investing & Savings
  compoundInterestConfig,
  tfsaGrowthConfig,
  rrspGrowthConfig,
  fhsaConfig,
  respConfig,
  respWithdrawalConfig,
  gicConfig,
  fireConfig,
  merConfig,
  // Retirement & Income
  rrspTaxSavingsConfig,
  retirementConfig,
  cppOasConfig,
  rrifConfig,
  // Taxes & Pay
  takeHomePayConfig,
  incomeTaxConfig,
  capitalGainsConfig,
  salesTaxConfig,
  // Debt & Net Worth
  netWorthConfig,
  debtPayoffConfig,
  carLoanConfig,
  lineOfCreditConfig,
  creditCardConfig,
  // Budgeting & Goals
  budgetConfig,
  emergencyFundConfig,
  savingsGoalConfig,
  // New tools (2026)
  firstTimeHomeBuyerConfig,
  freelancerTaxConfig,
  creditUtilizationConfig,
  debtToIncomeConfig,
  lifeInsuranceConfig,
  rentAffordabilityConfig,
  inflationImpactConfig,
];

export const getCalculator = (slug) => CALCULATORS.find((c) => c.slug === slug);
export const getCalculatorsByCategory = (categoryId) =>
  CALCULATORS.filter((c) => c.category === categoryId);
